import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stethoscope } from 'lucide-react';

const money = (n) => `€${Number(n || 0).toLocaleString()}`;

// Admin: platform appointments + revenue per specialty, as a simple bar list.
const AdminSpecialtyBreakdown = ({ specialtyBreakdown, loading }) => {
  const { t } = useTranslation('dashboard');
  const rows = Array.isArray(specialtyBreakdown?.data) ? specialtyBreakdown.data : [];
  const max = Math.max(1, ...rows.map((r) => Number(r.appointments) || 0));

  return (
    <div className="bg-white w-full rounded-xl p-4 border border-gray-200/50 shadow-md" data-testid="admin-specialty-breakdown">
      <h3 className="text-base sm:text-lg font-bold text-gray-900 flex items-center mb-3">
        <Stethoscope className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-[#4ABDBD]" />
        {t('dashboard.specialty_breakdown', 'By specialty')}
      </h3>
      {loading ? (
        <p className="text-sm text-gray-400 py-8 text-center">{t('dashboard.loading', 'Loading...')}</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-gray-400 py-8 text-center">{t('dashboard.no_data', 'No data for this period')}</p>
      ) : (
        <div className="space-y-3 max-h-72 overflow-y-auto custom-scrollbar pr-1">
          {rows.map((r) => (
            <div key={r.specialtyName} data-testid={`specialty-row-${r.specialtyName}`}>
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="text-gray-700 truncate pr-2">{r.specialtyName}</span>
                <span className="text-gray-500 shrink-0">{r.appointments} · {money(r.revenue)}</span>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#4ABDBD] to-[#3AA8A8] rounded-full"
                  style={{ width: `${Math.max(2, (Number(r.appointments) / max) * 100)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSpecialtyBreakdown;
